const GAMES_LIST = require('../../../shared/scripts/GAMES_LIST').default;
const DATE_RANGE_OPTIONS = require('./../DATE_RANGE_OPTIONS').default;
const KENO_DRAWS_RANGE_OPTIONS = require('./../KENO_DRAWS_RANGE_OPTIONS').default;
const ticketInfoInputContainerTemplate = require('./check-my-number-detail-ticket-inputs-container.handlebars');
const checkMyNumberDetailResultsTemplate = require('./check-my-number-detail-results.handlebars');
const checkMyNumberDetailPrizesAndOddsModalTemplate = require('./check-my-number-detail-results-prizes-and-odds-modal-template.handlebars');
const alertTemplate = require('../../../shared/templates/dismissible-alert-template.handlebars');
const loadingDotsTemplate = require('../../../shared/templates/loading-dots-row-template.handlebars');
var pastNumberAccordionTemplate = require('./../../draw-games/past-numbers/past-numbers-accordion.handlebars');
const EnableAutoTab=require('../../../shared/scripts/EnableAutoTab');
var scrollToElement = require('../../../shared/scripts/scrollToElement');
let checkMyNumberDetailService = new checkMyNumberDetailService();
let datefilterContainer=function (child){ return $(child).closest('.date-filter-container');}
var enableLogs=true;
let windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
let mobile = windowWidth < 500; 
$(document).ready(function () {
    if (!$('#check-my-numbers-detail-container').length) return;
   
    $('div[ID^="check-my-numbers-detail-container"]').each(function(){
        if($(this).parent().attr('id')!='main')  {
            $(this).css({"width": "100%"})
        }
        let initialGameId = $(this).find('#checknumbersdetail-gameid').val();
        let initialNumbers = $(this).find('#checknumbersdetail-numbers').val();
        let initialBonusBall = $(this).find('#checknumbersdetail-bonusball').val();
        let initialDateRangeDays = $(this).find('#checknumbersdetail-daterangedays').val();
        checkMyNumberDetailService.requestObject.gameId = parseInt(initialGameId);
    
    //INIT           
        showMatchOrderDropdown(checkMyNumberDetailService.requestObject.gameId);       
        createTicketInfoInputs(checkMyNumberDetailService.requestObject.gameId);
        initializeDateRangeSelector(checkMyNumberDetailService.requestObject.gameId); 
        if(checkMyNumberDetailService.requestObject.gameId===30){
            EnableFilters(checkMyNumberDetailService.requestObject.gameId);
        }        
    });
});
function EnableFilters(gameId)
{
    $('.check-my-numbers-detail-container-'+gameId).each(function(){       
       var selector=getSelectedContainer($(this)); 
    if(selector=='undefined'){return;}
    selector.find('.filter-seperator-text').hide();
    selector.find('.date-range-filter-container').hide();
    selector.find('.filter-action-links').hide(); 
    selector.find('.play-column').hide();
    selector.find('.filter-heading').hide();
    selector.find('.date-range-selector label').css('font-weight','bold');
    selector.find('#play-container-A').show().removeClass('col-sm-6');
    selector.find('#play-container-A label').html('Enter Your Draw Number:');
    let dropdown=selector.find('.date-filter-container');
    selector.find('.ticket-info-input-container').after(dropdown);
    selector.find('.date-filter-container').not(':first').remove();
    
    selector.find('.card-content.filter-container').wrap('<center></center>');
    selector.find('#play-A-inputs').css('display','block');
    });
}
//EVENTS
$('[id^=dd-date-range]').on('click', function () {
    if($(this).val()>0)  {
        datefilterContainer(this).find('.date-picker').val('').prop('disabled',true); 
    }else{    
        datefilterContainer(this).find('.date-picker').removeAttr('disabled');
    }
});

$('.date-picker').datepicker({autoclose: true}).on('changeDate', function(ev){    
    datefilterContainer(this).find('#dd-date-range').val(-1);
});
$('.date-picker').on('keyup', function () {       
    if($(this).val()!='')  {
        datefilterContainer(this).find('#dd-date-range').val(-1);
    }
});

$('[id^=btnCheckNumbers]').on('click', function () {
    let gameId=parseInt($(this).attr('gameid'));
    let formIsValid = validateForm($(this).parent().prev(),gameId);
    if (!formIsValid) return;
    if(enableLogs){
        console.log('btnCheckNumbers triggered: validateForm- '+gameId); 
    }
    getFormData($(this).parent().prev(),gameId);
    if(enableLogs){
        console.log('btnCheckNumbers triggered: getFormData- '+gameId); 
    }
    $(this).next().hide();
    getCheckMyNumberDetailResults($(this).closest('.row').prev('.row').find('#check-my-number-detail-results-container'));
});

$('.nav-tabs li, .panel-group .panel-heading').on('click',function(){
    let initialData=GetCheckmynumbersDatafromSession();
    ResetCheckmynumbersSession();
    if(enableLogs){
        console.log('initialData.gameId>0 '+(initialData.gameId>0));
    }
    if(initialData.gameId>0){
       checkMyNumberDetailService.requestObject.gameId = initialData.gameId;
       setInitialData(initialData.gameId,initialData.numbersAsString,initialData.bonusBall,initialData.dateRangeDays,initialData.matchOrder);
    }
    if(enableLogs){
        console.log('clearandResetAllInputswithResults(): called in tab click');
    }
    if(!initialData.gameId>0){
    clearandResetAllInputswithResults();}else{ 
        if(enableLogs){
        console.log('clearandResetAllInputswithResults(): not called in tab click bcz of initialData.gameId>0');
        }
    }
});

$('[id^=lnk-add-more-plays]').on('click', function () {     
    addFiveMorePlays(parseInt($(this).attr('gameid')));
    $(this).addClass('hidden');
});

$('[id^=lnk-clear-all-inputs]').on('click', function () {
    clearAllInputs();
});

function initializeDateRangeSelector(gameId) {
    const $dateRangeDropdownMenu = $('.check-my-numbers-detail-container-'+gameId +' .date-range-selector #dd-date-range');
    
    $dateRangeDropdownMenu.html(gameId===30?'':`<option value="0" selected>Choose...</option>`);
    (gameId===30?KENO_DRAWS_RANGE_OPTIONS:DATE_RANGE_OPTIONS).forEach((value) =>
     $dateRangeDropdownMenu.append(`<option value="${value.Value}">${value.Title}</option>`));
     if(gameId===30){
        $dateRangeDropdownMenu.val(1);
     }
}
function getSelectedContainer(current){    
    if(mobile){
        if(enableLogs){
        console.log('setInitialData: container entered to mobile view');
        }
        var selector=current.parent('.panel-body').parent();
        return selector;
    }else{
        var selector=current.parent('.tab-pane');
        return selector;
    }
}
function setInitialData(gameId, initialNumbers, initialBonusBall, initialDateRangeDays, initialMatchOrder) {
    $('.check-my-numbers-detail-container-'+gameId).each(function(){
    if(enableLogs){
        console.log('container Id: '+$(this).attr('id'));
    }
    var selector=getSelectedContainer($(this));    
    if(selector.attr('id')=='undefined'){      
        console.log('selector: undefined?');
          return;
    }
    if(enableLogs){
    console.log('selector id: '+selector.attr('id'));
    console.log('#btnCheckNumbers'+(parseInt(selector.find('#btnCheckNumbers').attr('gameid'))));
    console.log('dropdown data: '+selector.find('.date-range-selector #dd-date-range').html());
    }
    if(parseInt(selector.find('#btnCheckNumbers').attr('gameid'))===gameId) {
        if(enableLogs){console.log('initial data call '+gameId);}
    let firstPlayId = "A";
    //Set Date Range Selection
    selector.find('.date-range-selector #dd-date-range').find('option[value="'+initialDateRangeDays+'"]').prop('selected','selected')
    let predefinedDateRangeValue = selector.find('.date-range-selector #dd-date-range').val();
    checkMyNumberDetailService.requestObject.selectedPredefinedDateRange = predefinedDateRangeValue ? predefinedDateRangeValue : null;
    selector.find('.match-order-filter-container #dd-match-order').val(initialMatchOrder);
    //Set number/bonusball values on requestobject
    let firstPlayObject = checkMyNumberDetailService.requestObject.plays.find((el, i, arr) => {
        return el.playId === firstPlayId;
    });

    if (initialNumbers) {
        firstPlayObject.numbers = initialNumbers.split(",");
        firstPlayObject.bonusBall = !initialBonusBall ? "" : initialBonusBall;
        //fill first play with numbers/bonusball
        if(enableLogs){
        console.log(selector.find('#play-A-inputs'));
        }       
        let playNumbers = selector.find('#play-A-inputs');
        playNumbers.children('.number-input.bonus-ball').children('input').val(initialBonusBall);
        let numberInputs = playNumbers.children('.number-input:not(.bonus-ball)');
        firstPlayObject.numbers.forEach((v, i, a) => {
            if(enableLogs){console.log('inital number: '+v);}
            if($(numberInputs[i]).children('input').val()!=null){
            $(numberInputs[i]).children('input').val(v);
        }
        });
        selector.find('#btnCheckNumbers').trigger('click');
        if(enableLogs){console.log('it should not trigger for the next game');}
        return false;
        }
     }
    });    
}

function createTicketInfoInputsHtml(gameid, plays) {
    //TODO: Remove hardcoded Ids from here.. extend GAMES_LIST into a service with helper functions.. (ex. getPowerballId(), getGameById(20))
    let gameId=parseInt(gameid);
    let mappedGame = GAMES_LIST
        .map((v, i, a) => {
            return {
                isPowerball: gameId === 20,
                isMegaMillions: gameId === 15,
                isBankAMillion: gameId === 1070,
                isPick3: gameId === 1050,
                isPick4: gameId === 1040,
                isCash5: gameId === 1030,
                isCash4Life: gameId === 1065,
                isRaffle: gameId === 7,
                isKeno: gameId === 30,
                plays: plays,//(gameId === 30?plays.splice(1, 4):plays),
                game: v
            };
        }).find((item) => item.game.Id === gameId);
    return ticketInfoInputContainerTemplate(mappedGame);
}

function createTicketInfoInputs(gameId) {
    checkMyNumberDetailService.requestObject.gameId=gameId;
    let playIds = (["A", "B", "C", "D", "E"]);
    checkMyNumberDetailService.requestObject.plays=[];
    playIds.forEach(function (v, i, a) {
        let newPlay = checkMyNumberDetailService.newDefaultPlayObject();
        newPlay.playId = v;
        checkMyNumberDetailService.requestObject.plays.push(newPlay);
    });

    let html = createTicketInfoInputsHtml(gameId, checkMyNumberDetailService.requestObject.plays);
    $('.check-my-numbers-detail-container-'+gameId +' .ticket-info-input-container').html(html);    
    initializeNumberInputValidation(gameId);
}

function addFiveMorePlays(gameId) {    
    let playIds = ["F", "G", "H", "I", "J"];
    let startIndex = checkMyNumberDetailService.requestObject.plays.length - 1;
    playIds.forEach(function (v, i, a) {
        let newPlay = checkMyNumberDetailService.newDefaultPlayObject();
        newPlay.playId = v;
        checkMyNumberDetailService.requestObject.plays.push(newPlay);
    });

    let playsToBuild = checkMyNumberDetailService.requestObject.plays.filter((v, i, a) => i > startIndex);
    let html = createTicketInfoInputsHtml(gameId, playsToBuild);
    let $container = $('.check-my-numbers-detail-container-'+gameId +'  .ticket-info-input-container');
    $container.append(`<div class="divider"></div>`);
    $container.append(html);

    initializeNumberInputValidation(gameId);
}

function clearAllInputs() {
    //Reset number inputs
    let $numberInputs = $('.ticket-info-input-container').find('.number-input input');
    $numberInputs.val('');
    //reset checkbox inputs
    let $checkboxInputs = $('.ticket-info-input-container').find('.megaplier-checkbox input[type=checkbox]');
    $checkboxInputs.prop('checked', false)
}

function clearandResetAllInputs(){
    $('.date-picker').val('').removeAttr('disabled');;
    //$('[id^=dd-date-range]').val(0);  
    $('[id^=dd-date-range]').prop('selectedIndex',0);
    clearAllInputs();     
}
function clearandResetAllInputswithResults(){
    clearandResetAllInputs();
    $('.results-container').html('');
}

function showMatchOrderDropdown(gameId) {
    //TODO: extend GAMES_LIST into a service with helper functions.. (ex. getPowerballId(), getGameById(20))
    //TODO: Remove hardcoded Ids from here..

    //only display this dropdown if pick3(id=1050) or pick4(id=1040)
    let isPick3OrPick4 = gameId === 1050 || gameId === 1040;

    if (isPick3OrPick4) {
        $('.check-my-numbers-detail-container-'+gameId +' .match-order-filter-container').removeClass('hidden');
    }
}

function initializeNumberInputValidation(gameId) {
    $('.check-my-numbers-detail-container-'+gameId +' .ticket-info-input-container .play-column [id^=play-]:not([id$=checkbox]) .number-input input.numeric-only').on("keypress",function (event) {    
           var key=window.event ? event.keyCode : event.which;
    	   if(gameId==1040 || gameId==1050)
           {
            if ((key==8 || key==9 || key==46)||(key >=48 && key <= 57))
            return true;            
           }
           else{
            if ((key==8 || key==9 || key==46)||(key >=48 && key <= 57))
		    {
			    if(key!==48)return true;
			    if(key===48&&$(this).val()>0)
			   		   return true;
	        }           
           } 
        return false; 
     });
    //TO VALIDATE NUMBER INPUTS BY GAMES
   //Increased Cash 5 input number from 34 to 41
	 $(".ticket-info-input-container .play-column [id^=play-]:not([id$=checkbox]) .number-input input.numeric-only").on("keyup",function (event) {    
        var value=$(this).val();		   
        var parentClass=$(this).parent().attr('class');		  

        var maxNum=(parentClass.indexOf('keno-normal')>0?99999999:parentClass.indexOf('powerball-normal')>0?69:parentClass.indexOf('powerball-bonus')>0?26:parentClass.indexOf('megamillions-normal')>0?70:parentClass.indexOf('megamillions-bonus')>0?25:parentClass.indexOf('bankamillion-normal')>0?40:parentClass.indexOf('cash4life-normal')>0?60:parentClass.indexOf('cash4life-bonus')>0?4:41);		  
        // console.log('value-'+value+'parentClass-'+parentClass+'Max Num-'+maxNum);
        if(value>maxNum || value<0){
          $(this).val('');
        }          
        if(parentClass.indexOf('keno-normal')<=0){
            EnableAutoTab($(this),0); 			          
        }
    });	 
}

function validateForm($filterContainer,gameId) {
    let $dateRangeErrorContainer = $filterContainer.find('#checknumberdetail-daterange-validation-container');
    let $numberInputErrorContainer = $filterContainer.find('#checknumberdetail-numberinput-validation-container');
    $dateRangeErrorContainer.empty();
    $numberInputErrorContainer.empty();
    let dateRangeSelectionIsValid = validateDateRangeInputs($filterContainer,$dateRangeErrorContainer);
    let allNumberInputsAreValid = validateAllNumberInputs($filterContainer,$numberInputErrorContainer);
    return dateRangeSelectionIsValid && allNumberInputsAreValid;
}

function validateDateRangeInputs($filterContainer,$dateRangeErrorContainer) {
    let errors = [];
    let predefinedDateRangeValue =$filterContainer.find('#dd-date-range').val();
    let startDateValue = $filterContainer.find('#start-date-filter').val();
    let endDateValue = $filterContainer.find('#end-date-filter').val();

    if (predefinedDateRangeValue>0) {
        return true;
    }
    if (startDateValue && endDateValue) {
        return true;
    }
    errors.push({
        message: `Please choose a date range.`,
        severity: { error: true }
    });
    errors.forEach(function (v, i, a) {
        displayValidationAlert(v, $dateRangeErrorContainer)
    });
    return false;
}
function validateAllNumberInputs($filterContainer,$numberInputErrorContainer) {
    let errors = [];
    let $playContainers = $filterContainer.find('[id^=play-container-]');
    let allPlays = [];

    $.each($playContainers, function (index, value) {
        let thisPlayIsValid = true;
        let thisPlayNumbers = [];
        let $play = $(value);
        let thisPlayId = $play.attr('id').replace('play-container-', '');
        let $playLabel = $play.find('.play-label');
        let playNumbers = $play.find('[id^=play-][id$=inputs]');
        let normalNumbers = playNumbers.children('.number-input:not(.bonus-ball)');
        let shouldHaveBonusBallValue = playNumbers.find('.number-input.bonus-ball').length > 0;
        let bonusBallValue = playNumbers.children('.number-input.bonus-ball').children('input').val();

        $.each(normalNumbers, function (index, value) {
            thisPlayNumbers.push($(value).children('input').val());
        });

        let thisPlayNumbersWithValues = thisPlayNumbers.filter((v, i, a) => v.length > 0);
        let thisPlayNumbersWithoutValues = thisPlayNumbers.filter((v, i, a) => v.length == 0);

        if (thisPlayNumbers.length == thisPlayNumbersWithValues.length) {
            allPlays.push(thisPlayNumbers);
        }

        if (thisPlayNumbers.length == thisPlayNumbersWithValues.length || thisPlayNumbers.length == thisPlayNumbersWithoutValues.length) {
            if (shouldHaveBonusBallValue && bonusBallValue) {
                thisPlayIsValid = true;
                $playLabel.removeClass('invalid');
            }
        }
        else {
            thisPlayIsValid = false;
        }

        if (!thisPlayIsValid) {
            errors.push({
                message: `Invalid entries below.`,
                severity: { error: true }
            });
            $playLabel.addClass('invalid');
        }
    });

    if (errors.length > 0) {
        errors.forEach(function (v, i, a) {
            displayValidationAlert(v, $numberInputErrorContainer)
        });
        return false;
    } else if (allPlays.length == 0) {
        let error = {
            message: `Please enter at least one play.`,
            severity: { error: true }
        };
        displayValidationAlert(error, $numberInputErrorContainer);
        return false;
    } else {
        return true;
    }
}
function displayValidationAlert(alert, $container) {
    let html = alertTemplate({ alertData: alert });
    $container.append(html);
}
function getFormData($filterContainer,gameId) {
    let $playContainers =$filterContainer.find('[id^=play-container-]');    
    let predefinedDateRangeValue = $filterContainer.find('#dd-date-range').val();
    let startDateValue = $filterContainer.find('#start-date-filter').val();
    let endDateValue = $filterContainer.find('#end-date-filter').val();
    let matchOrderValue = $filterContainer.find('#dd-match-order').val();  
    
    checkMyNumberDetailService.requestObject.gameId=gameId;  
    checkMyNumberDetailService.requestObject.selectedPredefinedDateRange = predefinedDateRangeValue ? predefinedDateRangeValue : null;
    checkMyNumberDetailService.requestObject.dateRange.startDate = startDateValue ? startDateValue : null;
    checkMyNumberDetailService.requestObject.dateRange.endDate = endDateValue ? endDateValue : null;
    checkMyNumberDetailService.requestObject.matchOrder = matchOrderValue ? matchOrderValue : null;
    let playObject = null;
    
    $.each($playContainers, function (index, value) {
        let $play = $(value);
        let thisPlayId = $play.attr('id').replace('play-container-', '');
        console.log('$plays.find loop'+(index+' - ' +$play.attr('id')));
        playObject = checkMyNumberDetailService.requestObject.plays.find((el, i, arr) => {
           console.log('el.playId'+el.playId+' - thisPlayId'+thisPlayId);
            return el.playId === thisPlayId;
        });

        //reset numbers        
        try{
            console.log('playObject '+playObject);
            playObject.numbers = [];
        }
        catch(e){ 
            console.log(e.message);  
            console.log('playObject.numbers before reset '+playObject.numbers);
            console.log('playObject.numbers before reset '+playObject.numbers+'length'+playObject.numbers.length);
            console.log(playObject.numbers); 
        }
        let playNumbers = $play.find('[id^=play-][id$=inputs]');
        let bonusBallValue = playNumbers.children('.number-input.bonus-ball').children('input').val();
        let normalNumbers = playNumbers.children('.number-input:not(.bonus-ball)');
        let megaplierCheckbox = $play.find('[id^=play-][id$=megaplier-checkbox] input[type=checkbox]')[0];
        let powerplayCheckbox = $play.find('[id^=play-][id$=powerplay-checkbox] input[type=checkbox]')[0];
        let megaplierCheckboxValue = megaplierCheckbox ? megaplierCheckbox.checked : null;
        let powerplayCheckboxValue = powerplayCheckbox ? powerplayCheckbox.checked : null;
        console.log('normalNumbers '+normalNumbers.length);
        $.each(normalNumbers, function (index, value) {
            console.log('looping+ numbers in getFormData '+$(value).children('input').val());
            playObject.numbers.push($(value).children('input').val());
        });
        console.log('playObject.numbers '+playObject.numbers.length);
        playObject.bonusBall = bonusBallValue ? bonusBallValue : null;
        playObject.includeMegaPlier = megaplierCheckboxValue==null?powerplayCheckboxValue:megaplierCheckboxValue;
        playObject.includePowerPlay = powerplayCheckboxValue;
   
        //TODO: Validation?? WHERE/WHEN does this happen??
    });
    console.log('all passed from getFormData');
    try{
    console.log(checkMyNumberDetailService.requestObject.stringify());
}catch(e){
    console.log(e.message);
    console.log(checkMyNumberDetailService.requestObject.stringify);}
    return checkMyNumberDetailService.requestObject;
}
function getCheckMyNumberDetailResults($resultContainer) {
    showIsLoadingIcon($resultContainer);
    scrollToElement({ scrollToThis: $resultContainer});    
    if(enableLogs){console.log('checkMyNumberDetailService.requestObject- '+JSON.stringify(checkMyNumberDetailService.requestObject));}
    $.ajax({
        url: '/api/v1/games/checkNumbers',
        type: 'POST',
        data: checkMyNumberDetailService.requestObject,
        dataType: 'json'
    })
        .done(function (data) {
		   //var x = new Date('2020,10,01');   //Need to change date to 2020,10,26 RCW
			//var drawdate = $this.data('drawingdate');
			//var y  = new Date(drawdate); 
			//var drawdate = data('drawingdate');
			//alert("This the x date " + x + "this is the y time " + y);  //Testing only

            if (data.errors) {
                //TODO: Handle validation errors
            }
            else if(checkMyNumberDetailService.requestObject.gameId===30){
                if(enableLogs){ console.log('keno results: '+data.data);}
                var html = pastNumberAccordionTemplate({
                    pastDraws: data.data,
                    isDayNightGame: false,
                    accordionId: $resultContainer.attr('id'),
                    uniqueId: "Keno-30",
                    isKenoGame:true
                }); 
                $resultContainer.parent().addClass('past-numbers-container');
                $resultContainer.html('<h3 class="results-heading">Results</h3>'+html).addClass('panel-group');
                clearandResetAllInputs();
            }
             else {
                //Display Results
               if(enableLogs){ console.log('game results: '+data.data);}

                var html = checkMyNumberDetailResultsTemplate({
                    results: data.data
                });
                $resultContainer.html(html);                 
                if(checkMyNumberDetailService.requestObject.gameId==15 || checkMyNumberDetailService.requestObject.gameId==20){					
                    $('.todays-jackpot-display').removeClass('hide');
                }
				
			      if(checkMyNumberDetailService.requestObject.gameId==1030){
		       		$resultContainer.find('.result-table-container ul.selected-numbers :nth-child(1)').before('<li class="ball text day"><span>DAY:</span></li>');
					$resultContainer.find('.result-table-container ul.selected-numbers :nth-child(6)').after('<li class="ball empty"></li><li class="ball text night"><span>NIGHT:</span></li>');

				} 

                //if(checkMyNumberDetailService.requestObject.gameId==1040){
					//$resultContainer.find('.result-table-container ul.selected-numbers :nth-child(1)').before('<li class="ball text day"><span>DAY:</span></li>');
					//$resultContainer.find('.result-table-container ul.selected-numbers :nth-child(5)').after('<li class="ball empty"></li><li class="ball text night"><span>NIGHT:</span></li>');
				//}
                //if(checkMyNumberDetailService.requestObject.gameId==1050){
					//$resultContainer.find('.result-table-container ul.selected-numbers :nth-child(1)').before('<li class="ball text day"><span>DAY:</span></li>');
					//$resultContainer.find('.result-table-container ul.selected-numbers :nth-child(4)').after('<li class="ball empty"></li><li class="ball text night"><span>NIGHT:</span></li>');
                //}
                
                //if(checkMyNumberDetailService.requestObject.gameId==1040||checkMyNumberDetailService.requestObject.gameId==1050){
                    //var $isnotMatch=$resultContainer.find('.result-table-container ul.selected-numbers li.ball.isNotMatch');
                    //$isnotMatch.hide();$isnotMatch.prev().hide();$isnotMatch.next().hide();
                //}  
                if(checkMyNumberDetailService.requestObject.gameId==1030){
                    var iter=1;
                    if(enableLogs){console.log('check my number results loaded - entered in pick 5 '+checkMyNumberDetailService.requestObject.gameId);}
                    $resultContainer.find('.result-table-container ul.selected-numbers li.ball.isNotMatch').each(function(){
                        if(enableLogs){console.log(iter+' '+$(this).html());}
                        iter=iter+1;
                        if($(this).html()=='-'){ $(this).hide(); $(this).prev().hide();$(this).prev('.text').prev().hide(); $(this).next().hide(); }
                    });
                } 
                if(mobile){ 
                    if(checkMyNumberDetailService.requestObject.gameId==1030 ||checkMyNumberDetailService.requestObject.gameId==1040||checkMyNumberDetailService.requestObject.gameId==1050){             
                    $resultContainer.find('.result-table-container .result-mobile-view td .prizes-link').each(function(){
                        $(this).parent().hide();
                        $(this).parent().next().removeClass('center');
                    });
                    }
                    $resultContainer.find('.colonbreak').each(function(){
                    try{
                        let formattedHtml=$(this).html().replace(': ','<br>');
                        $(this).html(formattedHtml);            
                    }catch(err){
                        console.error('colon for break ('+$(this).html()+')error- '+err.message);
                    }
                });
            }
                //Initialize PrizesAndOdds Modals that were added by handlebars
                $('[id^="prizes-and-odds-modal-"]').modal({ show: false });
                $('[id^="prizes-and-odds-modal-"]').on('show.bs.modal', function () {
                    getPrizesAndOddsModal(this);
                })
            }
        });
}

function getPrizesAndOddsModal(thisModal) {
    let $this = $(thisModal);
    let requestObject = {
        drawingDate: $this.data('drawingdate'),
        gameId: checkMyNumberDetailService.requestObject.gameId
    };

    $.ajax({
        url: '/api/v1/prizesandodds',
        type: 'POST',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {
            let modalHtml = checkMyNumberDetailPrizesAndOddsModalTemplate({ prizesAndOdds: data });
            $this.html(modalHtml)
			var x = new Date('2020,10,26');   //Need to change date to 2020,10,26 RCW
			var drawdate = $this.data('drawingdate');
			var y  = new Date(drawdate); 
			//alert("This the x date " + x + "this is the y time " + y);  //Testing only
			// Modified and Added by RCW 10/21/2020 for Cash 5 rewrite
			if(checkMyNumberDetailService.requestObject.gameId==1030 && y >= x ){
     	       $('div[id^="prizes-and-odds-modal-"] table.table-responsive  tbody tr:nth-child(1)').before('<tr style="background: #fff;"><td colspan="3"><strong>Drawing Details</strong></td></tr>');								  
			   var strTotalAmount=$('div[id^="prizes-and-odds-modal-"] table.table-responsive  tfoot totalprizeamount').html();
               var arrTotalAmount=strTotalAmount.split('_');
			   var daytotalAmountRow='<tr><td class="align-left"><strong>My Total Prizes Won </strong></td><td>-</td><td>$'+arrTotalAmount[0]+'</td></tr>';
			   var nighttotalAmountRow='<tr><td class="align-left"><strong>Total Prizes Won </strong></td><td>-</td><td>$'+arrTotalAmount[1]+'</td></tr>';
			   $('div[id^="prizes-and-odds-modal-"] table.table-responsive  tbody').append(nighttotalAmountRow);
			   $('div[id^="prizes-and-odds-modal-"] table.table-responsive  tfoot').remove();
			} 
			else if(checkMyNumberDetailService.requestObject.gameId==1030)
			{ 
		       $('div[id^="prizes-and-odds-modal-"] table.table-responsive  tbody tr:nth-child(1)').before('<tr style="background: #fff;"><td colspan="3"><strong>Day Drawing Details</strong></td></tr>');					
			   var strTotalAmount=$('div[id^="prizes-and-odds-modal-"] table.table-responsive  tfoot totalprizeamount').html();
               var arrTotalAmount=strTotalAmount.split('_');
			   var daytotalAmountRow='<tr><td class="align-left"><strong>My Total Prizes Won </strong></td><td>-</td><td>$'+arrTotalAmount[0]+'</td></tr>';
			   var nighttotalAmountRow='<tr><td class="align-left"><strong>Total Prizes Won </strong></td><td>-</td><td>$'+arrTotalAmount[1]+'</td></tr>';
			   $('div[id^="prizes-and-odds-modal-"] table.table-responsive  tbody tr:nth-child(4)').after(daytotalAmountRow+'<tr style="background: #fff;"><td colspan="3"><strong>Night Drawing Details</strong></td></tr>');					
			   $('div[id^="prizes-and-odds-modal-"] table.table-responsive  tbody').append(nighttotalAmountRow);
			   $('div[id^="prizes-and-odds-modal-"] table.table-responsive  tfoot').remove();
			   }
			if(checkMyNumberDetailService.requestObject.gameId==1040 || checkMyNumberDetailService.requestObject.gameId==1050){			  
			   var strTotalAmount=$('div[id^="prizes-and-odds-modal-"] table.table-responsive  tfoot totalprizeamount').html();
			   var arrTotalAmount=strTotalAmount.split('_');
			   var daytotalAmountRow='<div class="col-xs-12"><div><strong>Day Drawing Details:</strong>&nbsp;&nbsp;<strong>Total Prizes Won </strong>- $'+arrTotalAmount[0]+'</div></div>';
			   var nighttotalAmountRow='<div class="col-xs-12"><div><strong>Night Drawing Details:</strong>&nbsp;&nbsp;<strong>Total Prizes Won </strong>- $'+arrTotalAmount[1]+'</div></div>';
			   $('div[id^="prizes-and-odds-modal-"] .modal-body .row').html(daytotalAmountRow+nighttotalAmountRow);			   
			   $('div[id^="prizes-and-odds-modal-"] table.table-responsive,div[id^="prizes-and-odds-modal-"] .prizes-and-odds-modal-short-description').remove();
			}			
        })
}

function showIsLoadingIcon(containerSelector) {
    var html = loadingDotsTemplate();
    $(containerSelector).html(html);
}

function checkMyNumberDetailService(options) {
    var defaultRequestObject = {
        gameId: null,
        selectedPredefinedDateRange: null,
        dateRange: {
            startDate: null,
            endDate: null
        },
        matchOrder: null,
        plays: []
    };

    this.requestObject = $.extend(true, defaultRequestObject, options);
    this.newDefaultPlayObject = () => {
        return {
            playId: null,
            numbers: [],
            bonusBall: null,
            includeMegaPlier: false,
            includePowerPlay: false
        }
    };
}

function GetCheckmynumbersDatafromSession(){
    try{   
        if(enableLogs) {
        console.log('GetCheckmynumbersDatafromSession '+(parseInt(sessionStorage.chkNumGameId)));
        }
          return {
            gameId: parseInt(sessionStorage.chkNumGameId),
            dateRangeDays: parseInt(sessionStorage.chkNumDateRangeDays),
            //numbers: numbers,
            numbersAsString: sessionStorage.chkNumNumbersAsString,
            bonusBall: sessionStorage.chkNumBonusBall,
            matchOrder: sessionStorage.chkNumMatchOrder
        };
    }
    catch(e){console.log(e.message); }
}
function ResetCheckmynumbersSession(){
    if(enableLogs){
    let data = "chkNumGameId: " + sessionStorage.chkNumGameId;
        data +="\n chkNumNumbersAsString:" + sessionStorage.chkNumNumbersAsString;
        data +="\n chkNumBonusBall:" + sessionStorage.chkNumBonusBall;
        data +="\n chkNumDateRangeDays:" + sessionStorage.chkNumDateRangeDays;
        data +="\n chkNumMatchOrder:" + sessionStorage.chkNumMatchOrder;
        console.log(data);
    }
    try{
        sessionStorage.removeItem("chkNumGameId");
        sessionStorage.removeItem("chkNumNumbersAsString");
        sessionStorage.removeItem("chkNumBonusBall");
        sessionStorage.removeItem("chkNumDateRangeDays");
        sessionStorage.removeItem("chkNumMatchOrder");
    }
    catch(e){console.log('error at reset session'+e.message);}
}


// WEBPACK FOOTER //
// ./features/check-my-numbers/check-my-number-detail/check-my-number-detail.js